import { Component, OnInit, ViewChild, Input, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute } from '@angular/router';

import { AppComponentGenericComponent } from '../custom/app-component-generic/app-component-generic.component';
import { DataService } from '../../services/data.service';

import { AnagraficaDettaglioParameter } from '../../models/person';

@Component({
  selector: 'app-situazione-contribuente',
  templateUrl: './situazione-contribuente.component.html',
  styleUrls: ['./situazione-contribuente.component.css']
})
export class SituazioneContribuenteComponent extends AppComponentGenericComponent implements OnInit {
	@ViewChild('anagrafica') anagrafica: any;
	@ViewChild('mw') mw: any;
	public idPerson: number = null;
	public idPersonBySub: number = null;
	private sub: any;
	private newPersonBool: boolean = false;

	associatiNums: any = "";//"99+";
	associatiSync: Subscription;

	locatariNums: any = "";
	locatariSync: Subscription;

	immobiliNums: any = "";
	immobiliSync: Subscription;

	mobiliNums: any = "";
	mobiliSync: Subscription;

	stipendiNums: any = "";
	stipendiSync: Subscription;

	contiCorrentiNums: any = "";
	contiCorrentiSync: Subscription;

	datoriLavoroNums: any = "";

	comuneSync: Subscription;
	praticheSync: Subscription;

	modalInput: any = {
		size: 'large-modal',
		title: 'Titolo',
		subtitle: 'sottotitolo',
		data: {
			idPerson: null
		}
	}

	anagraficaDettaglioParameter: AnagraficaDettaglioParameter = null;

	constructor(private _cdr: ChangeDetectorRef, private route: ActivatedRoute,	protected dataService: DataService) {
		super(dataService, 'situazione-contribuente');
	}

	ngOnInit() {
		console.log('SITUAZIONE CONTRIBUENTE INIT', this.idPerson);
		this.anagraficaDettaglioParameter = new AnagraficaDettaglioParameter(this.idPerson, "small", this.checkPermission('situazione-contribuente','write'));
		this.idPersonBySub = null;
		this.sub = this.route.params.subscribe(params => {
			 this.idPersonBySub = +params['id']; // (+) converts string 'id' to a number
			 // In a real app: dispatch action to load the details here.
		});
		this.praticheSync = this.dataService.pratiche$.subscribe(
			pratiche => {
				this.loadAnagraficaId();
			});
		this.associatiSync = this.dataService.getContribuentiService().associati$.subscribe(
		() => {
			this.reloadNumberThings();
		});
	this.locatariSync = this.dataService.locatari$.subscribe(
		() => {
			this.reloadNumberThings();
		});
	this.immobiliSync = this.dataService.beniImmobili$.subscribe(
		() => {
			this.reloadNumberThings();
		});
	this.mobiliSync = this.dataService.beniMobili$.subscribe(
		() => {
			this.reloadNumberThings();
		});
	// 		this.stipendiSync = this.dataService.datoriLavoro$.subscribe(
	// 			() => {
	// 				this.datoriLavoroNums = this.formatBadgeText(this.dataService.getDatoriLavoroByPersonId(this.idPerson));
	// 			});
	//contiCorrentiSync
		this.comuneSync = this.dataService.getComuniService().comune$.subscribe(
			(comune) => {
				console.debug("CMP|SITUAZIONE CONTRIBUENTE - PERSON COMUNE CHANGE pre:", this.anagrafica);
				if(this.anagrafica){
					if(!this.idPerson){
						this.newPerson();
					}else{
						this.setIdPerson(this.idPerson);
					}
					console.debug("CMP|SITUAZIONE CONTRIBUENTE - PERSON COMUNE CHANGE:", this.idPerson);
				}else{
					console.debug("CMP|SITUAZIONE CONTRIBUENTE - PERSON COMUNE NO ANAGRAFICA");
				}
				//this.reloadNumberThings();
		});
	}

	formatBadgeText(array: any){
		let arrayLength = array.length;
		let badgeText = "";
		if(arrayLength >= 100)
			badgeText = "99+";
		else{
			if(arrayLength > 0)
				badgeText = String(arrayLength);
		}
		return badgeText;
	}

	reloadNumberThings(){
		//	associati
		this.dataService.getContribuentiService().getAssociatiByPersonId(this.idPerson, (associati) => {
			console.log("assocati", associati);
			let associatiLength = associati.length;
			if(associatiLength >= 100){
				this.associatiNums = "99+";
			}else{
				if(associatiLength > 0)
					this.associatiNums = String(associatiLength);
				else
					this.associatiNums = "";
			}
		});

		//	locatari
		let locatariLength = this.dataService.getLocatariByPersonId(this.idPerson).length;
		if(locatariLength >= 100)
			this.locatariNums = "99+";
		else{
			if(locatariLength > 0)
				this.locatariNums = String(locatariLength);
			else
				this.locatariNums = "";
		}

		//	immobili
		let immobiliLength = this.dataService.getImmobiliByPersonId(this.idPerson).length;
			if(immobiliLength >= 100)
				this.immobiliNums = "99+";
			else{
				if(immobiliLength > 0)
					this.immobiliNums = String(immobiliLength);
				else
					this.immobiliNums = "";
			}

		//	mobili
		let mobiliLength = this.dataService.getMobiliByPersonId(this.idPerson).length;
			if(mobiliLength >= 100)
				this.mobiliNums = "99+";
			else{
				if(mobiliLength > 0)
					this.mobiliNums = String(mobiliLength);
				else
					this.mobiliNums = "";
			}
	}

	loadAnagraficaId(){
		//console.debug("CMP|SITUAZIONE CONTRIBUENTE - PRE:", this.idPerson, this.dataService.getUtentiService().getPermissions(), this.idPersonBySub);

		if(!this.dataService.getUtentiService().getPermissions()){
			console.debug("CMP|SITUAZIONE CONTRIBUENTE - CITTADINO");
			this.setIdPerson(this.dataService.getUtentiService().getUser().id_anagrafica);
		}else if(this.idPersonBySub){
			console.debug("CMP|SITUAZIONE CONTRIBUENTE - UTENTE SUB");
			this.setIdPerson(this.idPersonBySub);
		}
	}

	private setIdPerson(idPersonNew){
		this.idPerson = idPersonNew;
		this._cdr.detectChanges();
		this.anagrafica.editable = false;
		this.anagraficaDettaglioParameter = new AnagraficaDettaglioParameter(this.idPerson, "small", this.checkPermission('situazione-contribuente','write'));
	}

	private newPerson(){
		console.log("CMP|SITUAZIONE CONTRIBUENTE - newPerson editable pre", this.anagrafica.editable);
		this.anagrafica.setIdPerson(null);
		this.anagrafica.editable = true;
		this.newPersonBool = true;
		console.log("CMP|SITUAZIONE CONTRIBUENTE - newPerson editable post", this.anagrafica.editable);
	}

	private edit(){
		console.log("CMP|SITUAZIONE CONTRIBUENTE - edit editable", this.anagrafica.editable);
		this.anagrafica.editable = !this.anagrafica.editable;
		this.newPersonBool = false;
	}

	private salvaModifiche(){
		if(this.newPersonBool){
			this.anagrafica.insert();
		}
		else{
			this.anagrafica.update();
		}
		this.anagrafica.editable = false;
	}

	private scartaModifiche(){
		if(this.newPersonBool){
			let idFirstPerson = this.dataService.getContribuentiService().getFirstAnagrafica();
			if(idFirstPerson){
				this.setIdPerson(idFirstPerson);
			}else{
				this.setIdPerson(0);
			}
		}else{
			this.anagrafica.discard();
		}
		this.anagrafica.editable = false;
	}

	apriFind() {
		this.modalInput = {
			size: 'large-modal',
			title: 'Cerca Contribuente',
			subtitle: '',
			data: {
				idPerson: this.idPerson,
				standAlone: true
			}
		}
		this.mw.show('inner-find');
	}

	apriAssociati() {
		this.modalInput = {
			size: 'large-modal',
			title: 'Gestione Associati',
			subtitle: '',
			data: {
				idPerson: this.idPerson,
				standAlone: false
			}
		}
		console.debug("CMP|SITUAZIONE CONTRIBUENTE - APRI-ASSOCIATI", this.modalInput);
		this.mw.show('contribuente-associati');
	}

	apriLocatari() {
		this.modalInput = {
			size: 'large-modal',
			title: 'Gestione Locatari',
			subtitle: '',
			data: {
				idPerson: this.idPerson,
				standAlone: false
			}
		}
		this.mw.show('contribuente-locatari');
	}

	apriImmobili() {
		this.modalInput = {
			size: 'large-modal',
			title: 'Gestione Immobili',
			subtitle: '',
			data: {
				idPerson: this.idPerson,
			}
		}
		this.mw.show('contribuente-immobili');
	}

	apriMobili() {
		this.modalInput = {
			size: 'large-modal',
			title: 'Gestione Mobili',
			subtitle: '',
			data: {
				idPerson: this.idPerson,
			}
		}
		this.mw.show('contribuente-mobili');
	}

	apriStipendi(){
		this.modalInput = {
			size: 'large-modal',
			title: 'Gestione Stipendi',
			subtitle: '',
			data: {
				idPerson: this.idPerson,
			}
		}
		this.mw.show('contribuente-stipendi');
	}

	apriContiCorrenti(){
		this.modalInput = {
			size: 'large-modal',
			title: 'Gestione Conti Correnti',
			subtitle: '',
			data: {
				idPerson: this.idPerson,
			}
		}
		this.mw.show('contribuente-conti-correnti');
	}

	personChange(event: any){
		if(event && this.idPerson !== event){
			this.setIdPerson(event);
		}
		console.log("CMP|SITUAZIONE CONTRIBUENTE - personChange", event);
	}

	idPersonEmitted(event: any){
		if(event && this.idPerson !== event){
			this.setIdPerson(event);
		}
		console.log("CMP|SITUAZIONE CONTRIBUENTE - idPersonEmitted", event);
	}

	getModalOutput(event: any){
		console.debug('CMP|SITUAZIONE CONTRIBUENTE - EVENT:', event);
		let idPerson = event.anagrafica_id;
		if(idPerson && this.idPerson !== idPerson) {
			this.setIdPerson(idPerson);
			this.reloadNumberThings();
		}
	}

	ngOnDestroy() {
		if(this.praticheSync){
			this.praticheSync.unsubscribe();
		}
		if(this.comuneSync){
			this.comuneSync.unsubscribe();
		}
		if(this.sub){
			this.sub.unsubscribe();
		}
	}
}
